// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","load7":"Loader_load7__G4VPq"};